import { useCallback } from "react";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

type CloseReasonListItemProps = {
  checked: boolean;
  value: string;
  onSelect: (value: string) => void;
  title: string;
};

function CloseReasonListItem({
  checked,
  value,
  onSelect,
  title,
}: CloseReasonListItemProps) {
  const handleChange = useCallback(() => {
    onSelect(value);
  }, [onSelect, value]);
  return (
    <FixaListViewItem
      id={value}
      controlProps={{
        checked,
        value,
      }}
      onChange={handleChange}
      key={value}
      control="radiobutton"
      title={title}
    />
  );
}

export default CloseReasonListItem;
